<template>
    <default-calculator-layout :filter-width="filterWidth" :output-width="outputWidth" :calculator-title="calculatorTitle" :class="calcMainClass">
        <div slot="filter">
            <number-input
                v-model="LoanAmount"
                :label="labelLoanAmount"
                :tooltip-link="LoanAmountTooltip"
            />
            <number-input
                v-model="InterestRate"
                :label="labelInterestRate"
                symbol="%"
                symbol-aligned="right"
                precision="3"
                maxValue="100.000"
                inputmode="decimal"
                :tooltip-link="InterestRateTooltip"
            />
            <drop-down
                v-model="LoanTermInYears"
                :label="labelLoanTermInYears"
                :tooltip-link="LoanTermTooltip"
                :options="LoanTermInYearsList"
            />
        </div>
        <div slot="output">
            <div class="text-center calculate-amount-section loan-payment-section">
                <h3>Your monthly payment will be:</h3>
                <span class="calculate-amount">{{ monthlyPayment }}</span>
                <h4 class="next-step">Ready for the next step?</h4>
                <div></div>
                <button :class="destinationButtonCssClass" type="submit" @click="DestinationTarget ? redirect(DestinationTarget) : redirect()">
                    {{ DestinationButtonText }}
                </button>
                <div>
                    <advertising-disclosures
                        v-if="disclosureText"
                        :disclosure-text="DisclosureText"
                        :disclosure-tokens="DisclosureTokens"
                    />
                </div>
                <lt-logo v-if="ltLogo==1">
                    <small>NMLS#1136 Terms & Conditions Apply</small>
                </lt-logo>
            </div>
        </div>
        <div slot="footer">
            <div v-if="AmortizationBreakdown" class="row">
                <div class="col-xs-12">
                    <amortization-breakdown-table
                        :loan-amount="LoanAmount"
                        :loan-term-in-years="LoanTermInYears"
                        :interest-rate="InterestRate"
                    />
                </div>
            </div>
        </div>
    </default-calculator-layout>
</template>

<script>
    import Accounting from 'accounting';
    import AmortizationBreakdownTable from '~/components/amortization-breakdown-table.vue';
    import PaymentHelper from '~/helpers/payment';
    import LoanTermList from '~/constants/loan-term-list';
    import DefaultTooltip from '~/constants/tooltip-defaults';
    import BaseMixin from '~/mixin/base-mixin';
    import LtLogo from '~/components/lt-logo.vue';
    import DefaultCalculatorLayout from '~/layout/default-calculator.vue';

    export default {
        props: {
            filterTitle: {
                default: 'Monthly Loan Costs',
            },
            interestRateToken: {
                default: '5_1_ARM_RATE_INITIAL_225K',
            },
            labelLoanAmount: {
                default: 'Loan Amount:',
            },
            labelInterestRate: {
                default: 'Interest Rate:',
            },
            labelLoanTermInYears: {
                default: 'Loan Term:',
            },
            loanAmount: {
                default: 50000,
            },
            interestRate: {
                default: 0,
            },
            loanTermInYears: {
                default: 30,
            },
            amortizationBreakdown: {
                default: 0,
            },
            disclosureTokens: {
                default: '',
            },
            disclosureText: {
                default: '',
            },
            ltLogo: {
                default: '',
            },
            loanAmountTooltip: {
                default: DefaultTooltip.LoanAmount,
            },
            interestRateTooltip: {
                default: DefaultTooltip.InterestRate,
            },
            loanTermTooltip: {
                default: DefaultTooltip.LoanTerm,
            },
            destinationLinkOrId: {
                default: 'ns-calc-loan-payment',
            },
            destinationButtonCssClass: {
                default: 'btn btn-blue',
            },
            destinationButtonText: {
                default: 'Get Free Loan Offers',
            },
            loanTermInYearsListType: {
                default: 'mortgage',
            },
            destinationTarget: {
                default: '',
            },
            filterWidth: {
                default: 'col-xs-12 col-sm-5 col-md-4 filter-sec',
            },
            outputWidth: {
                default: 'col-xs-12 col-sm-7 col-md-8 result-sec',
            },
            fitSidebar: {
                default: 0,
            },
        },
        data() {
            return {
                InterestRateToken: this.interestRateToken,
                LoanAmount: this.loanAmount,
                InterestRate: typeof this.interestRate == 'undefined' ? 3.3 : this.interestRate,
                LoanTermInYears: this.loanTermInYears,
                AmortizationBreakdown: parseInt(this.amortizationBreakdown, 10),
                LoanTermInYearsList: LoanTermList.LoanTermInYearsList[this.loanTermInYearsListType],
                DisclosureText: this.disclosureText,
                DisclosureTokens: this.disclosureTokens,
                DestinationLinkOrId: this.destinationLinkOrId,
                DestinationButtonText: this.destinationButtonText,
                LoanAmountTooltip: parseInt(this.hideTooltip, 10) ? '' : this.loanAmountTooltip,
                InterestRateTooltip: parseInt(this.hideTooltip, 10) ? '' : this.interestRateTooltip,
                LoanTermTooltip: parseInt(this.hideTooltip, 10) ? '' : this.loanTermTooltip,
                DestinationTarget: this.destinationTarget,
                FitSidebar: this.fitSidebar,
            };
        },
        computed: {
            monthlyPayment() {
                return Accounting.formatMoney(PaymentHelper.monthlyPaymentUsingLoanTermInYears(Accounting.unformat(this.LoanAmount), this.LoanTermInYears, Accounting.unformat(this.InterestRate)), { precision: 2 });
            },
            calcMainClass() {
                return this.FitSidebar === 0 ? '' : 'sidebar-template';
            },
        },
        components: {
            AmortizationBreakdownTable,
            LtLogo,
            DefaultCalculatorLayout,
        },
        mixins: [BaseMixin],
    };
</script>
<style src="../../assets/styles/common.scss" lang="scss"></style>
<style src="../../assets/styles/calc-filter-output.scss" lang="scss" scoped></style>
<style src="./main.scss" lang="scss"></style>
